import { defineComponent } from 'vue'
import type { ICenteredProps } from './types'

const Centered = defineComponent<ICenteredProps>(
  (props, { slots }) => {
    return () => {
      const both = props.horizontal === props.vertical
      return (
        <div
          style={{
            display: 'flex',

            ...(both
              ? {
                  justifyContent: 'center',
                  alignItems: 'center'
                }
              : props.vertical
                ? {
                    alignItems: 'center'
                  }
                : { justifyContent: 'center' }),
            ...(props.wrap
              ? {
                  flexWrap: 'wrap',
                  flexDirection: 'column'
                }
              : {}),
            width: '100%',
            height: '100%'
          }}
        >
          {slots.default ? slots.default() : ''}
        </div>
      )
    }
  },
  { props: ['horizontal', 'vertical', 'wrap'] }
)

export default Centered
